/* eslint-disable @typescript-eslint/no-explicit-any */
import { baseURL, httpApi } from "api/http.api";
import axios from "axios";

export interface AuthData {
  email: string;
  password: string;
}

export interface SignUpRequest {
  firstName: string;
  lastName: string;
  email: string;
  password: string;
}

export interface ResetPasswordRequest {
  email: string;
}

export interface SecurityCodePayload {
  code: string;
}

export interface NewPasswordData {
  newPassword: string;
}

export interface LoginRequest {
  email: string;
  password: string;
}

export interface RefreshClient {
  client_id: string;
}

export interface RefreshTokenRequest {
  refreshToken: string;
}

export interface LoginResponse {
  access: string;
  refresh: any;
  user: any;
  user_id: number;
}

export const login = (loginPayload: LoginRequest): Promise<LoginResponse> =>
  httpApi.post<LoginResponse>("auth/token/", { ...loginPayload }).then(({ data }) => data);

export const signUp = (signUpData: SignUpRequest): Promise<any> =>
  axios
    .post<any>(baseURL + "users/user-custom/sign-up/", {
      ...signUpData,
    })
    .then(({ data }) => data);

export const refreshToken = (refreshToken: RefreshTokenRequest): Promise<LoginResponse> =>
  httpApi
    .post<LoginResponse>("CmsAuth?callType=persistent", { ...refreshToken })
    .then(({ data }) => data);

export const setClientToken = (request: { client_id: string }): Promise<LoginResponse> =>
  httpApi
    .post<LoginResponse>("CmsAuth?callType=set_client_of_account", {
      ...request,
    })
    .then(({ data }) => data);

export const resetPassword = (resetPasswordPayload: ResetPasswordRequest): Promise<undefined> =>
  httpApi.post<undefined>("forgotPassword", { ...resetPasswordPayload }).then(({ data }) => data);

export const verifySecurityCode = (securityCodePayload: SecurityCodePayload): Promise<undefined> =>
  httpApi
    .post<undefined>("verifySecurityCode", { ...securityCodePayload })
    .then(({ data }) => data);

export const setNewPassword = (newPasswordData: NewPasswordData): Promise<undefined> =>
  httpApi.post<undefined>("setNewPassword", { ...newPasswordData }).then(({ data }) => data);

export const googleLogin = (googleAuthData: any): Promise<LoginResponse> =>
  httpApi.post<LoginResponse>("users/google/", { ...googleAuthData }).then(({ data }) => data);

export const microsoftLogin = (microsoftReceivedCode: any): Promise<LoginResponse> =>
  httpApi
    .get<LoginResponse>("authorize_callback/?code=" + microsoftReceivedCode)
    .then(({ data }) => data);

export const getIntegrationList = (): Promise<any> =>
  httpApi.get<any>("/users/integrations/all-integrations/").then(({ data }) => data);

export const updateIntegrationStatus = (provider: any): Promise<any> =>
  httpApi.post<any>("users/integrations/enable-integrations/", provider).then(({ data }) => data);

export const unauthorizedGmail = (): Promise<any> =>
  httpApi.post<any>("users/gmail/unauthorize/", {}).then(({ data }) => data);

export const unauthorizedOutlook = (): Promise<any> =>
  httpApi.post<any>("users/outlook/unauthorize/", {}).then(({ data }) => data);

export const integrationSetOutlook = ({ code }: any): Promise<any> =>
  httpApi.get<any>("users/outlook/confirm-authorization/?code=" + code).then(({ data }) => data);

///users/info
export const getUserInfo = (): Promise<any> =>
  httpApi.get<any>("users/info").then(({ data }) => data);


export const deactivateAccount = (): Promise<any> =>
  httpApi.get<any>("users/deactivate-user/").then(({ data }) => data);